export default __webpack_public_path__ + "static/media/mental_wellbeing.802d2581.png";